import React from 'react';
import { useAuth } from '../../context/AuthContext';
import AccessDenied from './AccessDenied';

const ProtectedRoute = ({ permission, permissions, requireAll = false, children, message }) => {
  const { hasPermission, hasAnyPermission, hasAllPermissions } = useAuth();

  let allowed = true;

  if (permission) {
    allowed = hasPermission(permission);
  } else if (permissions) {
    allowed = requireAll ? hasAllPermissions(...permissions) : hasAnyPermission(...permissions);
  }

  if (!allowed) return <AccessDenied message={message} />;
  return children;
};

export default ProtectedRoute;